import React from 'react';

const PortfolioWalletMarginHistoryFormModal = React.lazy(() => import('../components/FormModal'));
const portfolioWalletMarginHistoryModalRegistry = {
    personalize_portfolioWalletMarginHistoryId: PortfolioWalletMarginHistoryFormModal
};
export default portfolioWalletMarginHistoryModalRegistry;
